import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {useEditTableEventTracking} from 'src/hooks/user/useEditTableEventTracking';
import {setUserActiveTemplate} from 'src/openapi/admin/apis/UserSearchTemplateApi';
import {TemplateType} from 'src/openapi/admin/models/TemplateType';
import {useAppDispatch} from 'src/store/hooks';

import type {UserSearchTemplate} from 'src/openapi/admin/models/UserSearchTemplate';

type Props = {
    userId: number,
    onSuccess: () => void,
    place: string,
};

const TRACKING_TEMPLATE_TYPE_CAPTIONS: Record<string, string> = {
    [TemplateType.CUSTOM]: 'Custom',
    [TemplateType.DEFAULT]: 'Default',
};

export const useSetActiveSearchTemplate = ({userId, onSuccess, place}: Props) => {
    const apiDispatch = useAppDispatch();
    const {selectLayoutSubmit} = useEditTableEventTracking();

    const eventAction = useCallback((template: UserSearchTemplate) => {
        selectLayoutSubmit({place, templateType: TRACKING_TEMPLATE_TYPE_CAPTIONS[template.templateType]});
        return apiDispatch(setUserActiveTemplate({
            userId,
            activeTemplateRequest: {templateId: template.templateId, searchType: template.searchType},
        }));
    }, [userId, apiDispatch, place, selectLayoutSubmit]);

    return useCommonEventHook({eventAction, onSuccess});
};
